import { LoadingButton } from '@mui/lab'
import { Alert, AlertTitle } from '@mui/material'
import { SubscriptionStatus } from 'types'

const WARNING_MESSAGES: Partial<Record<SubscriptionStatus, { title: string; message: string }>> = {
  [SubscriptionStatus.PastDue]: {
    title: 'Payment Past Due',
    message: 'Your last payment could not be processed. Update your card or use Pay Now.',
  },
  [SubscriptionStatus.Canceled]: {
    title: 'Subscription Canceled',
    message:
      'Your subscription has been canceled. Reactivate your subscription to regain access to all features.',
  },
  [SubscriptionStatus.Incomplete]: {
    title: 'Payment Incomplete',
    message:
      'Your subscription setup is incomplete. Please complete your payment to activate your subscription.',
  },
  [SubscriptionStatus.Unpaid]: {
    title: 'Payment Required',
    message: 'Your subscription is unpaid. Please update your payment method to restore access.',
  },
}

export function SubscriptionWarningBanner({
  status,
  onPayNow,
  loading = false,
  disabled = false,
}: {
  status: SubscriptionStatus
  onPayNow: () => void
  loading?: boolean
  disabled?: boolean
}) {
  const warningContent = WARNING_MESSAGES[status]

  if (!warningContent) {
    return null
  }

  const showPayNow = status !== SubscriptionStatus.Canceled

  return (
    <Alert
      severity="warning"
      action={
        showPayNow ? (
          <LoadingButton
            variant="contained"
            color="warning"
            size="small"
            onClick={onPayNow}
            loading={loading}
            disabled={disabled}
          >
            Pay Now
          </LoadingButton>
        ) : undefined
      }
    >
      <AlertTitle>{warningContent.title}</AlertTitle>
      {warningContent.message}
    </Alert>
  )
}
